export const BREAKPOINTS = {
  SMALL: 280,
  MEDIUM: 650,
  LARGE: 1000,
};
